export default __webpack_public_path__ + "static/media/FlyingFrog34.16f3565f.png";